import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64cc3e8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "default-layout" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "ad-hidden" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "ad" }

import BaseHeader from '@/components/Headers/BaseHeader.vue'
import AD from '@/components/AD.vue'
import { computed, onMounted, watch } from 'vue'

import { useUserStore } from '@/stores/user'
import PromoPopup from '@/components/Popup/PromoPopup.vue'
import { useAuthStore } from '@/stores/auth'
import { ADV_IMAGE } from '@/helpers/globalVars'

export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {

const userStore = useUserStore()
const authStore = useAuthStore()

const currentTheme = computed(() => userStore.theme)
watch(currentTheme, () => {
  if (currentTheme.value) {
    const container = document.getElementById('app')
    if (container) {
      container.setAttribute('theme', currentTheme.value)
    }
  }
})

const isShowPromoPopup = computed(() => authStore.isShowPromoPopup)

onMounted(() => {
  userStore.getUserAsync()
  userStore.getThemeAsync()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!_ctx.isAuth && isShowPromoPopup.value)
          ? (_openBlock(), _createBlock(PromoPopup, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseHeader)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        class: "img_hidden",
        src: `/img/${_unref(ADV_IMAGE)}`,
        alt: _unref(ADV_IMAGE)
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(AD)
    ])
  ]))
}
}

})